import React from "react";

const Input = ({ type = "text", placeholder, className = "", ...props }) => {
  const classes = `w-full px-4 py-2 bg-slate-100 border border-slate-200 rounded-lg text-text-primary placeholder-text-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${className}`;
  return (
    <input
      type={type}
      placeholder={placeholder}
      className={classes}
      {...props}
    />
  );
};

export default Input;
